import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-right-panel',
  templateUrl: './auth-right-panel.component.html',
  styleUrls: ['./auth-right-panel.component.scss']
})
export class AuthRightPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
